import { authHeader } from '../../_helpers';
import axios from 'axios';

export const competencyListSevice = {
    competencyListData,
}

axios.defaults.headers.common = authHeader();
let token = localStorage.getItem('access_token')


function competencyListData(data) {
    return axios.post(`/analytics/list/organisation/competency/?access_token=${token}`,data)
        .then(response => {
            return response;
        });
}


// WEBPACK FOOTER //
// ./src/_services/Analyze/competencyList.service.js